import mLogin from './login'
import mFindPwd from './find-pwd'
import mUsers from './users'

const custom = {
  path: 'm',
  component: resolve => require(['../../pages/m'], resolve),
  children: [
    mLogin,
    mFindPwd,
    mUsers
  ]
}

export default custom
